/*******************************************************************************
OPEN DEFAULT TAB
Opens the default tab box for scroll-tabs.
*******************************************************************************/

import toggleSubPages from './toggle-sub-pages';

export default function openDefault() {
    const scrollTabSections = $('.scroll-tabs .scroll-tab');

    // Loop through all the scroll tab containers on the page
    scrollTabSections.each(function() {

      // Prevent tabs from defaulting to the wrong tab when closed.
      //$(this).removeClass('was-selected');
      //$(this).removeClass('is-selected');

      // Select the dropdown
      if ($(this).data('name') === 'Daily Sites') {
        $(this).addClass('is-selected');
        //$(this).addClass('was-selected'); // Mark as last opened tab
        //toggleSubPages($(this).data('name')); // Add active state
      }

    });
}
